export var ResourceKeys;
(function (ResourceKeys) {
  ResourceKeys["LOCALES"] = "locales";
  ResourceKeys["COUNTRIES"] = "countries";
  ResourceKeys["TIMEZONES"] = "timezones";
  ResourceKeys["TITLES"] = "titles";
  ResourceKeys["ORGATYPES"] = "organizationTypes";
})(ResourceKeys || (ResourceKeys = {}));
